import { CHART_COLORS } from "@/pages/CreatorAnalytics/constants";
import type { ChartColumn, ICharacterTimeseriesPoint, IChartDataResult, ITimeseriesPoint, MetricTab } from "@/pages/CreatorAnalytics/types";

import { toDate } from "./toDate";

export const buildChartData = (
  activeTab: MetricTab,
  timeseries: (ITimeseriesPoint | ICharacterTimeseriesPoint)[],
  favoritesAvailableFrom: string,
): IChartDataResult => {
  const dateCol: ChartColumn = { type: "date", label: "Date" };

  switch (activeTab) {
    case "requests":
      return {
        columns: [dateCol, "Requests", "Unique Users"],
        rows: timeseries.map((point) => [toDate(point.date), point.requests, point.uniqueUsers]),
        colors: [CHART_COLORS.requests, CHART_COLORS.uniqueUsers],
        vAxisTitle: "Count",
      };

    case "depth":
      return {
        columns: [dateCol, "Avg Depth (messages)"],
        rows: timeseries.map((point) => [toDate(point.date), point.avgDepth]),
        colors: [CHART_COLORS.depth],
        vAxisTitle: "Messages",
      };

    case "favorites": {
      const favData = timeseries.filter((point) => point.date >= favoritesAvailableFrom);
      return {
        columns: [dateCol, "Likes", "Unlikes", "Net Likes"],
        rows: favData.map((point) => [toDate(point.date), point.likes, point.unlikes, point.netLikes]),
        colors: [CHART_COLORS.likes, CHART_COLORS.unlikes, CHART_COLORS.netLikes],
        vAxisTitle: "Count",
      };
    }

    case "rating":
      return {
        columns: [dateCol, "Avg Rating", "Ratings Count"],
        rows: timeseries.filter((point) => point.avgRating !== null).map((point) => [toDate(point.date), point.avgRating, point.ratingsCount]),
        colors: [CHART_COLORS.rating, CHART_COLORS.uniqueUsers],
        vAxisTitle: "Value",
      };

    default:
      return { columns: [], rows: [], colors: [], vAxisTitle: "" };
  }
};
